import { render } from "./ResultsSection.vue?vue&type=template&id=2169bd4a"
import script from "./ResultsSection.vue?vue&type=script&lang=js"
export * from "./ResultsSection.vue?vue&type=script&lang=js"

import "./ResultsSection.vue?vue&type=style&index=0&id=2169bd4a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__